export type CacheType = 'memory' | 'session' | 'hybrid';

export interface HttpCachePolicyConfig {
  endpoint: string | RegExp;
  cacheType: CacheType;
  cacheKey: string;
}

export const HTTP_CACHE_POLICY_CONFIG: HttpCachePolicyConfig[] = [
  {
    endpoint: '/channels/b2b-portal/consultants/customers',
    cacheType: 'hybrid',
    cacheKey: 'b2b_cache_customers_list',
  },
  {
    endpoint: '/channels/b2b-portal/customers/details',
    cacheType: 'memory',
    cacheKey: 'b2b_customer_details',
  },
  {
    endpoint: /\/channels\/b2b-portal\/depots\/[^/?]+\/portfolio/,
    cacheType: 'memory',
    cacheKey: 'b2b_performance_kpi',
  },
  {
    endpoint:
      /\/channels\/b2b-portal\/customers\/accounts\/[^/?]+\/transactions/,
    cacheType: 'memory',
    cacheKey: 'b2b_account_transactions',
  },
];
